
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";

@Component
export default class AilmentSelectInput extends Vue {
  @Model("update:selectedAilments", { type: Array }) readonly selectedAilments!: Models.Ailment[];
  @Prop({ type: Array, default: () => [] }) readonly ailments!: Models.Ailment[];
  @Prop({ type: String, default: "Ailments" }) readonly label!: string;
  @Prop({ type: Boolean, default: true }) readonly isRequired!: boolean;
  @Prop({ type: String, default: "Select Ailments" }) readonly dialogTitle!: string;
  @Prop({ type: String, default: "outlined" }) readonly actionVariant!: "text" | "outlined";
  @Prop({ type: String, default: "primary" }) readonly saveColor!: string;
  @Prop({ type: [String, Number], default: 640 }) readonly maxWidth!: string | number;
  @Prop({ type: Boolean, default: false }) readonly isLocked!: boolean;

  dialog: boolean = false;
  search: string = "";
  draftAilments: Models.Ailment[] = [];

  get filteredAilments(): Models.Ailment[] {
    const term = this.search.trim().toLowerCase();
    const list = !term ? this.ailments : this.ailments.filter((a) => (a.ailment || "").toLowerCase().includes(term));
    return [...list].sort((a, b) => (a.ailment || "").localeCompare(b.ailment || ""));
  }

  get sortedSelectedAilments(): Models.Ailment[] {
    return [...this.selectedAilments].sort((a, b) => (a.ailment || "").localeCompare(b.ailment || ""));
  }

  openDialog() {
    if (this.isLocked) {
      return;
    }

    this.search = "";
    this.draftAilments = [...this.selectedAilments];
    this.dialog = true;
  }

  closeDialog() {
    this.dialog = false;
    this.draftAilments = [...this.selectedAilments];
  }

  @Watch("dialog")
  onDialogChanged(nextValue: boolean, previousValue: boolean) {
    if (previousValue && !nextValue) {
      this.$nextTick(() => requestAnimationFrame(() => (document.activeElement as HTMLElement | null)?.blur()));
    }
  }

  isSelected(ailment: Models.Ailment) {
    return this.draftAilments.some((a) => (a.guid || a.ailment) === (ailment.guid || ailment.ailment));
  }

  toggleAilment(ailment: Models.Ailment) {
    let updated: Models.Ailment[];
    if (this.isSelected(ailment)) {
      updated = this.draftAilments.filter((a) => (a.guid || a.ailment) !== (ailment.guid || ailment.ailment));
    } else {
      updated = [...this.draftAilments, ailment];
    }
    this.draftAilments = updated;
  }

  clearSelection() {
    this.$emit("update:selectedAilments", []);
  }

  saveSelection() {
    this.$emit("update:selectedAilments", [...this.draftAilments]);
    this.closeDialog();
  }
}
